/**
 * @Author:      ge.yuankai
 * @DateTime:    2018-3-12 20:13:08
 * @Description: 变更主体信息
 */
'use strict';
angular.module("changeMainOperInfoModule",['changeMainOperInfoRouter']).
controller('changeMainOperInfoCtrl', ['$scope','$stateParams','httpService','$sce',function($scope,$stateParams,httpService,$sce){
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus(){
    };

    function initData(){
    };
}]);